/* ==========================================================================
   Peonia Boutique · Mejoras de tienda (DAR Media)
   - Barra de progreso de envío gratis (cart drawer)
   - Recálculo de mensualidades (MSI) al cambiar de variante
   - Botón de compra fijo en móvil (pixel-safe)
   Vanilla JS, sin dependencias. Defensivo: si algo no existe, no rompe nada.
   ========================================================================== */
(function () {
  'use strict';

  function formatMoney(cents) {
    try {
      if (window.theme && theme.Currency && theme.settings && theme.settings.moneyFormat) {
        return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
      }
    } catch (e) {}
    return '$' + (Math.round(cents) / 100).toFixed(2);
  }

  /* ---------- A-01 · Barra de envío gratis ------------------------------- */
  function updateShippingBars(totalPriceCents) {
    var bars = document.querySelectorAll('[data-free-shipping-bar]');
    if (!bars.length) return;

    bars.forEach(function (bar) {
      var threshold = parseInt(bar.dataset.threshold, 10);
      if (!threshold || threshold <= 0) return;

      var remaining = threshold - totalPriceCents;
      var pct = Math.min(100, Math.round((totalPriceCents / threshold) * 100));
      if (pct < 0) pct = 0;

      var fill = bar.querySelector('[data-fsb-fill]');
      var msg = bar.querySelector('[data-fsb-msg]');
      if (fill) fill.style.width = pct + '%';

      if (remaining <= 0) {
        bar.classList.add('is-reached');
        if (msg) msg.innerHTML = bar.dataset.msgSuccess || '';
      } else {
        bar.classList.remove('is-reached');
        if (msg) {
          var tpl = bar.dataset.msgRemaining || '[amount]';
          msg.innerHTML = tpl.replace('[amount]', formatMoney(remaining));
        }
      }
    });
  }

  function refreshShippingFromCart() {
    // El mini-cart CMX gestiona su propia barra; si no hay barra nativa, no hacemos nada.
    if (!document.querySelector('[data-free-shipping-bar]')) return;
    var route = (window.theme && theme.routes && theme.routes.cart) || '/cart.js';
    fetch(route, { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateShippingBars(cart.total_price); })
      .catch(function () {});
  }

  // El drawer reconstruye su HTML al añadir/quitar; reinyectamos el estado.
  document.addEventListener('cart:updated', function (evt) {
    if (evt.detail && evt.detail.cart) {
      updateShippingBars(evt.detail.cart.total_price);
    } else {
      refreshShippingFromCart();
    }
  });
  document.addEventListener('ajaxProduct:added', refreshShippingFromCart);
  document.addEventListener('cart:open', refreshShippingFromCart);

  /* ---------- A-03 · Mensualidades (MSI) en vivo ------------------------- */
  function updateInstallments(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-installments]').forEach(function (el) {
      var months = parseInt(el.dataset.months, 10);
      if (!months || months < 2) return;
      var amountEl = el.querySelector('[data-installments-amount]');
      if (amountEl) amountEl.innerHTML = formatMoney(Math.round(variant.price / months));
    });
  }

  /* ---------- UX-03 · Botón de compra fijo (móvil) ----------------------- */
  function updateStickyPrice(variant) {
    if (!variant || typeof variant.price !== 'number') return;
    document.querySelectorAll('[data-sticky-price]').forEach(function (el) {
      el.innerHTML = formatMoney(variant.price);
    });
  }

  document.addEventListener('variant:change', function (evt) {
    var variant = evt.detail && evt.detail.variant;
    if (!variant) return;
    updateInstallments(variant);
    updateStickyPrice(variant);
  });

  function initStickyAtc() {
    var sticky = document.querySelector('[data-sticky-atc]');
    if (!sticky) return;

    var sectionId = sticky.dataset.sectionId;
    var section = document.querySelector('.product-section[data-section-id="' + sectionId + '"]')
      || document.querySelector('.product-section');
    if (!section) return;

    var nativeBtn = section.querySelector('[data-add-to-cart]');
    var anchor = section.querySelector('.product-single__meta') || nativeBtn;
    if (!nativeBtn || !anchor) return;

    // El botón fijo dispara el ATC nativo (mantiene pixel y tracking intactos)
    var stickyBtn = sticky.querySelector('[data-sticky-atc-btn]');
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        nativeBtn.click();
      });
    }

    // Reflejar disponibilidad del botón nativo
    function syncDisabled() {
      var disabled = nativeBtn.hasAttribute('disabled');
      if (stickyBtn) stickyBtn.disabled = disabled;
    }
    syncDisabled();
    document.addEventListener('variant:change', syncDisabled);

    // Mostrar la barra solo cuando ya pasamos (hacia abajo) el ATC nativo
    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          if (scrolledPast) {
            sticky.classList.add('is-visible');
            sticky.setAttribute('aria-hidden', 'false');
          } else {
            sticky.classList.remove('is-visible');
            sticky.setAttribute('aria-hidden', 'true');
          }
        });
      });
      observer.observe(nativeBtn);
    }
  }

  /* ---------- Init ------------------------------------------------------- */
  function init() {
    refreshShippingFromCart();
    initStickyAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
